(function () {
  function initQuantitySelector(selector) {
    var input = selector.querySelector('[data-quantity-input]');
    var minus = selector.querySelector('[data-quantity-minus]');
    var plus = selector.querySelector('[data-quantity-plus]');

    if (!input || !minus || !plus) return;

    function getValue() {
      var value = parseInt(input.value, 10);
      return isNaN(value) ? 1 : value;
    }

    function getMin() {
      var min = parseInt(input.getAttribute('min'), 10);
      return isNaN(min) ? 1 : min;
    }

    function getMax() {
      var max = parseInt(input.getAttribute('max'), 10);
      return isNaN(max) ? null : max;
    }

    function setValue(value) {
      var min = getMin();
      var max = getMax();

      value = Math.max(value, min);

      if (max !== null) {
        value = Math.min(value, max);
      }

      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    minus.addEventListener('click', function () {
      setValue(getValue() - 1);
    });

    plus.addEventListener('click', function () {
      setValue(getValue() + 1);
    });

    input.addEventListener('change', function () {
      setValue(getValue());
    });
  }

  function initAllQuantitySelectors() {
    document.querySelectorAll('[data-quantity-selector]').forEach(initQuantitySelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllQuantitySelectors);
  } else {
    initAllQuantitySelectors();
  }
})();